// Utils
import { prop } from '../../utils/immutableHelper';

export const asNum = (val) => val || 0;

export const getX = (obj) => asNum(prop('x', obj) || prop('left', obj));
export const getY = (obj) => asNum(prop('y', obj) || prop('top', obj));
